import React from 'react';

import authService from '../../../services/auth.service';

import AreYouSureModal from '../../form-components/AreYouSureModal.component';
import DotdotdotButton from '../../form-components/DotdotdotButton.component';
import Box from '@mui/material/Box';
import { ResourceType } from '../../../@types/resource-type';
import { toast } from 'react-toastify';

import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { useWorkspaceContext } from '../../../context/workspaceContext';
import { addOrUpdateUser, displayApiKey } from '../../../utils/service-user-account-utils';
import Typography from '@mui/material/Typography';
import ServiceUserAccount from '../../../@types/service-user-account';
import serviceUserAccountService from '../../../services/service-user-account.service';

export default function ServiceUserActionsMenu(props: {
    user: ServiceUserAccount
}): React.ReactElement {
    const [confirmDeleteUser, setConfirmDeleteUser] = React.useState<boolean>(false);
    const { 
        setDeletedWorkspaceObject,
        setWorkspaceObjects,
        workspaceObjects
    } = useWorkspaceContext();

    const { user } = props;

    function onReissueApiKey(): void {
        serviceUserAccountService.reissueServiceUserKey(user).then((updatedUser: ServiceUserAccount) => {
            displayApiKey(updatedUser);
           
            if (workspaceObjects?.objectType === ResourceType.SERVICE_USER_ACCOUNTS) {
                setWorkspaceObjects({ objectType: ResourceType.SERVICE_USER_ACCOUNTS, resources: addOrUpdateUser(updatedUser, workspaceObjects.resources as ServiceUserAccount[]) });
            }
            toast.success('API key reissued successfully');
        }).catch((error) => {
            toast.error('Error reissuing API key - ' + error.message);
        });
    }

    function onDelete(): void {
        setConfirmDeleteUser(true);
    }




    return (
        <Box tabIndex={0} onClick={(event: any): void => {
            event.stopPropagation();
        }}>
            <DotdotdotButton>
                {
                    authService.isSuperUser() && <MenuItem id='edit' onClick={onReissueApiKey}>Reissue API Key</MenuItem>
                }
                <Divider />
                {
                    authService.isSuperUser() && <MenuItem id='delete' onClick={onDelete}>Delete</MenuItem>
                }
            </DotdotdotButton>

            <AreYouSureModal
                open={confirmDeleteUser}
                title={`Delete Service User "${user.username}"?`}
                onConfirm={(): void => {
                    serviceUserAccountService.deleteUserById(user.id).then(() => {
                        setDeletedWorkspaceObject({
                            objectType: ResourceType.SERVICE_USER_ACCOUNTS,
                            id: user.id,
                            children: []
                        });
                        setWorkspaceObjects({ objectType: ResourceType.SERVICE_USER_ACCOUNTS });

                    }).catch((error) => {
                        toast.error('Error deleting service user - ' + error.message);
                    }).finally(() => {
                        setConfirmDeleteUser(false);
                    });
                }}
                onClose={(): void => {
                    setConfirmDeleteUser(false);
                }}
            >
                <Typography variant='body1'>Are you sure you want to delete this service user?</Typography>
            </AreYouSureModal>
        </Box>
    );
}

